<template>
  <div>
    <page-heading :title="$t(`${translationPrefix}.title`)"></page-heading>

    <el-card>
      <el-tabs v-model="activeName">
        <el-tab-pane label="User Profile" name="first">
          <el-row :gutter="20">
            <el-col :span="8">
              
            </el-col>
            <el-col :span="16">
              <user-profile-form :profile="currentProfile" v-if="currentUser" :userId="currentUser.id" />
            </el-col>
          </el-row>
        </el-tab-pane>
        <el-tab-pane label="Account Profile" name="second">
          <el-row :gutter="20">
            <el-col :span="8">
              
            </el-col>
            <el-col :span="16">
              <account-profile-form v-if="currentUser" />
            </el-col>
          </el-row>
        </el-tab-pane>
        <el-tab-pane label="Company Profile" name="third" :disabled="!currentUser.admin" v-auth="'admin'">
          <el-row :gutter="20">
            <el-col :span="8">
              
            </el-col>
            <el-col :span="16">
              <company-settings-form />
            </el-col>
          </el-row>
        </el-tab-pane>
      </el-tabs>
    </el-card>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';

  import UserProfileForm from '@/components/profile/UserProfileForm';
  import AccountProfileForm from '@/components/user/AccountProfileForm';
  import CompanySettingsForm from '@/components/company/CompanySettingsForm';

  export default {
    name: 'ProfileSettingsPage',
    components: {
      userProfileForm: UserProfileForm,
      accountProfileForm: AccountProfileForm,
      companySettingsForm: CompanySettingsForm,
    },
    data() {
      return {
        activeName: 'first',
        translationPrefix: 'pages.userAccountProfile',
      };
    },
    computed: {
      ...mapGetters('entities/profiles', ['currentProfile']),
      ...mapGetters('entities/users', ['currentUser']),

    },
  };
</script>




// WEBPACK FOOTER //
// src/pages/ProfileSettings.vue